import { Header } from './donor-header'

export const Donor = { Header }
